import { useState } from "react";
import { GALLERY } from "../data/content";
import { Instagram } from "lucide-react";
import { useScrollReveal } from "../hooks/useScrollReveal";

const GalleryItem = ({ src, i }) => {
  const [tilt, setTilt] = useState({ rx: 0, ry: 0, scale: 1 });
  const onMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width;
    const y = (e.clientY - rect.top) / rect.height;
    setTilt({ rx: -(y - 0.5) * 8, ry: (x - 0.5) * 8, scale: 1.02 });
  };
  return (
    <div
      data-testid={`gallery-item-${i}`}
      onMouseMove={onMove}
      onMouseLeave={() => setTilt({ rx: 0, ry: 0, scale: 1 })}
      className="masonry-item group relative cursor-zoom-in"
      style={{
        transform: `perspective(900px) rotateX(${tilt.rx}deg) rotateY(${tilt.ry}deg) scale(${tilt.scale})`,
        transition: "transform 0.45s cubic-bezier(0.22, 1, 0.36, 1)",
        transformStyle: "preserve-3d",
      }}
    >
      <img
        src={src}
        alt={`Tiramisu artisanal Amyu — création gourmande n°${i + 1}`}
        loading="lazy"
        decoding="async"
        className="w-full h-auto block"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-amyu-ink/40 via-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
    </div>
  );
};

export const Galerie = () => {
  const { ref, visible } = useScrollReveal();

  return (
    <section
      id="galerie"
      data-testid="gallery-section"
      ref={ref}
      className="relative py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div
          className="text-center max-w-2xl mx-auto mb-12 transition-all duration-1000"
          style={{
            opacity: visible ? 1 : 0,
            transform: `translateY(${visible ? 0 : 30}px)`,
          }}
        >
          <span className="text-xs uppercase tracking-[0.2em] text-coral font-medium">
            Galerie
          </span>
          <h2 className="font-display text-4xl md:text-6xl mt-3 leading-[1.02]">
            L'univers Amyu en
            <span className="italic text-coral"> images.</span>
          </h2>
          <a
            href="https://instagram.com/amyu.off"
            target="_blank"
            rel="noreferrer"
            data-testid="gallery-instagram-link"
            className="inline-flex items-center gap-2 mt-6 text-sm text-amyu-ink hover:text-coral transition-colors"
          >
            <Instagram size={16} /> Suis-nous @amyu.off
          </a>
        </div>

        <div className="masonry" data-testid="gallery-masonry">
          {GALLERY.map((src, i) => (
            <GalleryItem key={src} src={src} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
